import styled from 'styled-components';
import { PersonOPT } from '@insly/qmt-reactjs-ui-lib';

export const PolicyHolderPersonOPT = styled(PersonOPT)`
  flex: 1;
`;
